export const newsList = [
  {
    id: "n1",
    title: "《星海纪元》第三季正式定档十月，全新预告片公开",
    summary: "官方于本周公开了《星海纪元》第三季的定档预告，银河远征军即将踏上新的旅程，主角林星晨也将迎来命运的转折。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20futuristic%20star%20fleet%20sailing%20through%20a%20glowing%20nebula%2C%20bright%20yellow%20and%20orange%20highlights%2C%20dramatic%20cinematic%20composition%2C%20highly%20detailed%20digital%20painting%2C%20epic%20sci%20fi%20mood%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=banana-news-01&orientation=landscape",
    date: "2026-10-12",
    source: "香蕉动漫编辑部",
    tags: ["定档", "科幻", "新番"],
    content: [
      "备受期待的国产科幻动画《星海纪元》第三季终于官宣定档，将于十月下旬正式开播。官方同步放出了时长两分半的定档预告，展现了银河远征军在未知星域遭遇的全新危机。",
      "从预告片中可以确认，第三季将继续围绕主角林星晨的成长展开。本季不仅会有全新的星舰登场，制作组还透露将揭开「星海之种」背后的核心谜团，剧情节奏相较前两季会更加紧凑。",
      "制作人表示，第三季在作画与分镜上投入了大量资源，宇宙战与角色情感两条线索将交替推进，力求兼顾视觉冲击与人物塑造。",
      "《星海纪元》第三季将于十月下旬每周五更新，香蕉动漫将持续跟进后续资讯，敬请关注。",
    ],
  },
  {
    id: "n2",
    title: "剧场版《樱花之约》票房突破十亿，刷新国产爱情动画纪录",
    summary: "上映三周，剧场版《樱花之约》累计票房正式突破十亿，成为近年来最叫好又叫座的国产青春爱情动画电影。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20anime%20movie%20key%20visual%20of%20a%20teenage%20couple%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%2C%20golden%20afternoon%20light%2C%20romantic%20cinematic%20wide%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text&width=800&height=450&seq=banana-news-02&orientation=landscape",
    date: "2026-10-09",
    source: "香蕉动漫编辑部",
    tags: ["剧场版", "票房", "爱情"],
    content: [
      "上映仅三周，剧场版《樱花之约》累计票房正式突破十亿大关，刷新了近五年国产青春爱情动画电影的票房纪录。",
      "影片以小镇高中的毕业季为背景，讲述了两个少年在离别前完成约定的温暖故事。细腻的情感描写与精致的画面表现，让不少观众在影院落泪。",
      "不少影迷表示，片中关于「约定」与「成长」的表达引发了强烈共鸣。发行方透露，影片的周边衍生与特别场次活动也在陆续筹备中。",
      "《樱花之约》目前仍在各大影院热映中，尚未观看的观众可以抓紧时间走进影院。",
    ],
  },
  {
    id: "n3",
    title: "人气新番《机械之心》首播评分登顶，制作团队接受专访",
    summary: "《机械之心》开播首集便登上平台评分榜首，制作团队在专访中分享了机甲设定与人物塑造背后的思考。",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20illustration%20of%20a%20giant%20mecha%20launching%20into%20a%20starry%20night%20sky%2C%20motion%20trails%2C%20glowing%20warm%20orange%20sparks%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20digital%20painting%2C%20intense%20energetic%20mood%2C%20no%20text&width=800&height=450&seq=banana-news-03&orientation=landscape",
    date: "2026-10-06",
    source: "香蕉动漫编辑部",
    tags: ["新番", "机甲", "专访"],
    content: [
      "本季新番《机械之心》开播首集便登上平台评分榜首，凭借扎实的机甲设计与紧凑的剧情节奏赢得了观众的广泛好评。",
      "在随后的专访中，制作团队透露，本作的主角机体在设计上参考了大量真实的航空器结构，力求在「帅气」与「合理」之间取得平衡。",
      "关于人物塑造，导演表示主角雷戈的成长并不是一蹴而就的，团队希望通过一次次任务中的选择，让角色的信念逐渐清晰。",
      "《机械之心》目前每周更新一集，后续剧情将进入主角与宿敌的正面对决，香蕉动漫将持续跟进。",
    ],
  },
  {
    id: "n4",
    title: "《幻境学院》角色人气投票结果公布，夜见初雪位列第一",
    summary: "官方公布《幻境学院》年度角色人气投票结果，银发学生会长夜见初雪以压倒性票数登顶，官方同步公开纪念立绘。",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20silver%20haired%20magical%20academy%20student%20casting%20a%20glowing%20golden%20spell%2C%20floating%20runes%2C%20warm%20magic%20light%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text&width=800&height=450&seq=banana-news-04&orientation=landscape",
    date: "2026-10-03",
    source: "香蕉动漫编辑部",
    tags: ["角色", "投票", "奇幻"],
    content: [
      "官方近日公布了《幻境学院》年度角色人气投票的最终结果，银发学生会长夜见初雪以压倒性的票数位列第一，官方同步公开了冠军角色的纪念立绘。",
      "本次投票共持续两周，参与人数刷新了系列纪录。排名第二与第三的分别是主角团的两位成员，票数差距并不悬殊。",
      "官方同时宣布，冠军角色将在后续的特别篇剧集中获得更多戏份，相关内容正在紧张制作中。",
      "更多《幻境学院》的角色资料与作品情报，欢迎前往香蕉动漫的角色介绍专区查看。",
    ],
  },
  {
    id: "n5",
    title: "经典重制：《时空旅人》4K 修复版将于年底上线",
    summary: "经典动画《时空旅人》的 4K 修复版正式公布，制作方在保留原作风格的基础上对画面与音效进行了全面升级。",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20lone%20traveler%20standing%20before%20a%20glowing%20time%20portal%2C%20warm%20amber%20light%2C%20floating%20clock%20fragments%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20digital%20painting%2C%20mysterious%20mood%2C%20no%20text&width=800&height=450&seq=banana-news-05&orientation=landscape",
    date: "2026-09-28",
    source: "香蕉动漫编辑部",
    tags: ["重制", "经典", "修复"],
    content: [
      "曾陪伴一代观众成长的经典动画《时空旅人》，近日正式公布了 4K 修复版本的计划，预计将于今年年底与观众见面。",
      "制作方表示，本次修复在保留原作画风与手绘质感的前提下，对分辨率、色彩与音效进行了全面升级，力求让老观众重温感动、新观众无缝入坑。",
      "修复团队透露，部分原版底片因年代久远已经受损，他们耗时数月逐帧比对与还原，只为了让经典画面以最好的状态回归。",
      "《时空旅人》4K 修复版的具体上线时间仍在确认中，香蕉动漫将持续关注并第一时间带来报道。",
    ],
  },
  {
    id: "n6",
    title: "国创动画崛起：《山海食记》斩获国际动画节大奖",
    summary: "以中华美食与神话为灵感的国创动画《山海食记》，在某国际动画节上斩获最佳剧集奖项，再次展现国创实力。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20anime%20illustration%20of%20a%20warm%20food%20stall%20street%20at%20dusk%20with%20soft%20lantern%20glow%20and%20rising%20steam%2C%20warm%20yellow%20and%20orange%20palette%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text&width=800&height=450&seq=banana-news-06&orientation=landscape",
    date: "2026-09-24",
    source: "香蕉动漫编辑部",
    tags: ["国创", "获奖", "美食"],
    content: [
      "以中华美食与上古神话为灵感的国创动画《山海食记》，在近日举行的国际动画节上斩获最佳剧集奖项，再次向世界展现了国创动画的实力。",
      "评委在颁奖词中特别提到，本作将美食的烟火气与神话的奇想巧妙融合，用温暖的故事打动人心，是一部兼具文化底蕴与国际表达的佳作。",
      "主创团队在获奖感言中表示，他们希望用动画让更多人感受到中华美食背后的人情味，未来会继续打磨后续剧集。",
      "《山海食记》目前正在连载中，喜欢治愈系与美食题材的观众不容错过。",
    ],
  },
];